/** 平台管理路由守卫：仅平台超管可进入 /platform/* */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '@/contexts/AppContext';

export default function PlatformGate({ children }: { children: React.ReactNode }) {
  const { isPlatformAdmin } = useAppContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isPlatformAdmin) {
      navigate('/403', { replace: true });
    }
  }, [isPlatformAdmin, navigate]);

  if (!isPlatformAdmin) return null;
  return <>{children}</>;
}
